import { FC, PropsWithChildren, useRef } from "react";
import useDisclosure from "@/hooks/useDisclosure";
import IconAdd from "@/assets/imgs/svg/icon-add.svg";
import IconRemove from "@/assets/imgs/svg/icon-remove.svg";
import clsx from "clsx";

interface Props {
  title: string;
  expandable?: boolean;
  defaultOpen?: boolean;
  isNew?: boolean;
}

const NavigationSection: FC<PropsWithChildren<Props>> = ({
  title,
  expandable = true,
  defaultOpen = false,
  isNew = false,
  children,
}): JSX.Element => {
  const { isOpen, toggle } = useDisclosure(defaultOpen);
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div className="grid gap-8">
      <button
        className="flex items-center justify-between gap-4"
        onClick={expandable ? toggle : undefined}
        aria-expanded={expandable ? isOpen : true}
        aria-controls="navigation-content"
      >
        <div className="flex items-center gap-8">
          <span className="text-sm font-bold line-clamp-1">{title}</span>
          {isNew && (
            <span className="text-tiny text-gray-950 bg-yellow-500 px-1 py-1 tracking-tight leading-none rounded-xxs">
              NEW
            </span>
          )}
        </div>
        {expandable && (
          <span className="transition-transform duration-300 ease-in-out">
            {isOpen ? (
              <IconRemove width={16} height={16} />
            ) : (
              <IconAdd width={16} height={16} />
            )}
          </span>
        )}
      </button>

      <hr />

      <div
        id="navigation-content"
        ref={contentRef}
        className={clsx(
          "grid transition-[grid-template-rows] duration-200 ease-in-out",
          // アコーディオンを閉じているときはoverflow-hiddenを適用
          !isOpen && "overflow-hidden",
          // アコーディオンが開閉しない場合はoverflow-visibleを適用
          !expandable && "!overflow-visible",
        )}
        style={{
          gridTemplateRows: expandable ? (isOpen ? "1fr" : "0fr") : "1fr",
        }}
      >
        <div className="min-h-0">{children}</div>
      </div>
    </div>
  );
};

export default NavigationSection;
